export default {
    title: 'Static/AmwalInstallmentsGuide',
    parameters: {
        notes: `
# Amwal Installments Guide Component

A reusable web component that displays a comprehensive guide about Amwal Bank Installments. 
This component includes information about how the installments work, eligibility requirements, 
payment schedules, and frequently asked questions.

## Features

- **Bilingual Support**: Seamlessly switch between English and Arabic
- **Responsive Design**: Optimized for all screen sizes
- **Interactive Elements**: Collapsible FAQ sections
- **Accessible**: Built with WCAG guidelines in mind

## Usage

\`\`\`html
<amwal-installments-guide
  locale="en"
></amwal-installments-guide>
\`\`\`

## Props

- **locale**: Language ('en' or 'ar')
    `,
        layout: 'fullscreen',
    },
    argTypes: {
        locale: {
            options: ['en', 'ar'],
            control: { type: 'select' },
            description: 'Language selection',
            table: {
                defaultValue: { summary: 'en' },
            },
        }
    },
};

const Template = (args) => `
  <div style="width: 100%; min-height: 100vh;">
    <amwal-installments-guide
      locale="${args.locale}"
    ></amwal-installments-guide>
  </div>
  
  <script>
    // Add event listeners for any custom events
    document.querySelectorAll('amwal-installments-guide').forEach((element) => {
      // You can add custom event listeners here if needed
      console.log('Amwal Installments Guide component loaded');
    });
  </script>
`;

// Story 1: English Version
export const EnglishVersion = Template.bind({});
EnglishVersion.args = {
    locale: 'en'
};
EnglishVersion.parameters = {
    docs: {
        description: {
            story: 'The guide displayed in English with default settings.',
        },
    },
};

// Story 2: Arabic Version
export const ArabicVersion = Template.bind({});
ArabicVersion.args = {
    locale: 'ar'
};
ArabicVersion.parameters = {
    docs: {
        description: {
            story: 'The guide displayed in Arabic with default settings.',
        },
    },
};